/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 *
 *  @author estelle.giuly
 *
 */
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';
import {SkeletonElementsModule} from 'skeleton-elements/angular';

import {EmployeeFormComponent} from './employee-form.component';

import {TabsModule} from 'ngx-bootstrap/tabs';
import {TimeModule} from '../../+payrolls/prepare/time/time.module';
import {ConfigurationModule} from '../../+configuration/configuration.module';
import {ApiModule} from '../api/api.module';
import {ChangeTrackingModule} from '../change-tracking/change-tracking.module';
import {DocumentsModule} from '../documents/documents.module';
import {EmployeesListModule} from '../employees-list/employees-list.module';
import {EmployeesMenuModule} from '../employees-menu/employees-menu.module';
import {EmployeesSharedModule} from '../employees/employees-shared.module';
import {FormGeneratorModule} from '../form-generator/form-generator.module';
import {HrCalendarModule} from '../hr-calendar/hr-calendar.module';
import {LogEventModule} from '../log-event/log-event.module';
import {ModalModule} from '../modal/modal.module';
import {PipesModule} from '../pipes/pipes.module';
import {SdconnectModule} from '../sdconnect/sdconnect.module';
import {UiModule} from '../ui/ui.module';
import {UserModule} from '../user/user.module';


@NgModule({
  imports: [
    ApiModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    UiModule,
    ChangeTrackingModule,
    EmployeesSharedModule,
    DocumentsModule,
    EmployeesListModule,
    TabsModule,
    ModalModule,
    PipesModule,
    UserModule,
    EmployeesMenuModule,
    FormGeneratorModule,
    HrCalendarModule,
    LogEventModule,
    ConfigurationModule,
    SdconnectModule,
    SkeletonElementsModule,
    TimeModule
  ],
  declarations: [
    EmployeeFormComponent
  ],
  exports: [
    EmployeeFormComponent
  ],
  providers: []
})

export class EmployeeFormModule {
}
